// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2026-05-25 21:10:12 +0200 (Mon, 25 May 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 163262 $
//  Purpose   : reducers utils
// =============================================================================
import { handleAction as _handleAction } from 'redux-actions';
export const handleAction = (matcher, reducer, initialState = {})=>/* most reducers dont declare initialState
   */ _handleAction(matcher, reducer, initialState);
export const handleSubState = (key, reducers, initialSubState)=>(state = {}, action)=>{
        /* manage a substate slice on key
     */ let subState = state[key];
        let nextSubState = reducers.reduce((ss, r_f)=>r_f(ss, action), subState);
        if (subState === undefined) {
            nextSubState = {
                ...initialSubState,
                ...nextSubState
            };
        }
        if (nextSubState !== subState) {
            // some changes received
            return {
                ...state,
                [key]: nextSubState
            };
        }
        return state;
    };
// Reduce multiple reducers into a single reducer from left to right and merge their initial states.
// https://github.com/lutangar/reduce-merge-reducers/blob/master/src/index.js
// used for loading reducers from packages
export function reduceMergeReducers(...reducers) {
    /* reduce all reducers and merge their output (assuming dict form)
   */ return (previous, current)=>{
        let isInitial = previous === undefined;
        return reducers.reduce((p, r)=>{
            if (isInitial) {
                return {
                    ...r(undefined, current),
                    ...p
                };
            }
            return r(p, current);
        }, {
            ...previous
        });
    };
}
